import { Button } from '@repo/shadcn';
import { BiPackage, BiPieChart, BiPlus } from 'react-icons/bi';
import { FaUserShield } from 'react-icons/fa';
import { Link } from 'react-router-dom';

import { Route } from '@/constants';

export const HeaderAction = () => {
    return (
        <>
            <div className="flex justify-end">
                <div className="flex flex-wrap gap-4">
                    <Link to={Route.POS_NEW}>
                        <Button>
                            <BiPlus className="mr-2 h-4 w-4" /> New Sale
                        </Button>
                    </Link>
                    <Link to={Route.STOCK_ALL_PRODUCTS}>
                        <Button variant="outline">
                            <BiPackage className="mr-2 h-4 w-4" /> Manage
                            Inventory
                        </Button>
                    </Link>
                    <Link to={Route.CUSTOMERS}>
                        <Button variant="outline">
                            <FaUserShield className="mr-2 h-4 w-4" /> Customer
                            List
                        </Button>
                    </Link>
                    <Link to={Route.SALES}>
                        <Button variant="outline">
                            <BiPieChart className="mr-2 h-4 w-4" /> Sales
                        </Button>
                    </Link>
                    <Button
                        variant="outline"
                        // onClick={() => openModal(MODAL_ROUTE.MAKE_PAYMENT)}
                    >
                        <Link to={Route.CUSTOMERS} className="flex gap-0.5">
                            <BiPieChart className="mr-2 h-4 w-4" /> Make Payment
                        </Link>
                    </Button>

                    <Button
                        variant="outline"
                        // onClick={() => openModal(MODAL_ROUTE.PURCHASE_PAYMENT)}
                    >
                        <Link to={Route.SUPPLIERS} className="flex gap-0.5">
                            <BiPieChart className="mr-2 h-4 w-4" /> Pay Supplier
                        </Link>
                    </Button>
                </div>
            </div>
        </>
    );
};
